export default {
  name: 'marking--docHMassInput',
  apiService: 'shoes',
  apiPath: '/admin/doc/func/upload',
  urlParamName: 'marking--docHMassInput',
};
